import styled from 'styled-components';

export const PlanContainer = styled.div`
  margin-top: 28px;
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: 8px;
  padding: 32px 32px 32px 32px;
  &:last-child {
    margin-bottom: 30px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const ButtonWrapper = styled.div`
  margin-top: 32px;
`;

export const Details = styled.div`
  margin-top: 32px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;
